import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-purple-900 to-pink-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-600 rounded-xl flex items-center justify-center">
                <i className="ri-customer-service-2-line text-white text-2xl"></i>
              </div>
              <span className="text-2xl font-bold">ReceptionGenie</span>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Your AI-powered receptionist that never sleeps. Handle calls, book appointments, 
              and delight customers 24/7 with intelligent automation.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/profile.php?id=61584515561103" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/receptiongenie.ai" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">Features</a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">Pricing</a>
              </li>
              <li>
                <a href="/how-it-works" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">How It Works</a>
              </li>
              <li>
                <a href="#faq" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">FAQ</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-pink-400 mt-1"></i>
                <a href="tel:+18886009252" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">
                  +1 (888) 600-9252
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-pink-400 mt-1"></i>
                <a href="mailto:support@receptiongenie.ai" className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer">
                  support@receptiongenie.ai
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-pink-400 mt-1"></i>
                <span className="text-gray-300">
                  Available 24/7 Nationwide
                </span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400">
              © {currentYear} ReceptionGenie.ai. All rights reserved.
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="hover:text-pink-400 transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/terms-of-service" className="hover:text-pink-400 transition-colors cursor-pointer">Terms of Service</Link>
              <Link to="/cookie-policy" className="hover:text-pink-400 transition-colors cursor-pointer">Cookie Policy</Link>
              <Link to="/refund-policy" className="hover:text-pink-400 transition-colors cursor-pointer">Refund Policy</Link>
              <Link to="/accessibility-statement" className="hover:text-pink-400 transition-colors cursor-pointer">Accessibility Statement</Link>
              <Link to="/data-request" className="hover:text-pink-400 transition-colors cursor-pointer">Data Request</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
